import { render, staticRenderFns } from "./StatisticsOnTheProportionOfProofing.vue?vue&type=template&id=2bbbef33&scoped=true&"
import script from "./StatisticsOnTheProportionOfProofing.vue?vue&type=script&lang=js&"
export * from "./StatisticsOnTheProportionOfProofing.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsOnTheProportionOfProofing.vue?vue&type=style&index=0&id=2bbbef33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbbef33",
  null
  
)

export default component.exports